import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootStateType } from "../..";

export type LookupCategoryType = "partnerType" | "partnerVertical";

export type LookupDataItemType = {
  ID: number;
  value: string;
  metadata?: unknown;
  description?: string | null;
};

type LookupDataStateType = {
  categories: Record<LookupCategoryType, LookupDataItemType[]>;
  status: {
    listLoading: Record<LookupCategoryType, boolean>;
    createLoading: boolean;
    deleteLoading: boolean;
    mappingsLoading: boolean;
    errorMessage: string;
  };
};

const initialState: LookupDataStateType = {
  categories: {
    partnerType: [],
    partnerVertical: [],
  },
  status: {
    listLoading: {
      partnerType: false,
      partnerVertical: false,
    },
    createLoading: false,
    deleteLoading: false,
    mappingsLoading: false,
    errorMessage: "",
  },
};

const lookupDataSlice = createSlice({
  name: "lookup-data",
  initialState,
  reducers: {
    setLookupCategoryLoading: (
      state,
      action: PayloadAction<{ category: LookupCategoryType; loading: boolean }>
    ) => {
      state.status.listLoading[action.payload.category] = action.payload.loading;
    },
    setLookupCategoryData: (
      state,
      action: PayloadAction<{
        category: LookupCategoryType;
        data: LookupDataItemType[];
      }>
    ) => {
      state.categories[action.payload.category] = action.payload.data;
      state.status.errorMessage = "";
    },
    setLookupCreateLoading: (state, action: PayloadAction<boolean>) => {
      state.status.createLoading = action.payload;
    },
    setLookupDeleteLoading: (state, action: PayloadAction<boolean>) => {
      state.status.deleteLoading = action.payload;
    },
    setLookupMappingsLoading: (state, action: PayloadAction<boolean>) => {
      state.status.mappingsLoading = action.payload;
    },
    setLookupErrorMessage: (state, action: PayloadAction<string>) => {
      state.status.errorMessage = action.payload;
    },
  },
});

export const lookupDataSliceReducer = lookupDataSlice.reducer;
export const lookupDataSliceAction = lookupDataSlice.actions;

export const selectLookupDataState = (state: RootStateType) => state.lookup_data;
export const selectLookupCategoryData = (
  state: RootStateType,
  category: LookupCategoryType
) => selectLookupDataState(state).categories[category];
export const selectLookupStatus = (state: RootStateType) =>
  selectLookupDataState(state).status;
